import { message } from "antd";
import AppointmentService from "../../Services/AppointmentService";

export const FETCH_WALLET_REQUEST = "FETCH_WALLET_REQUEST";
export const FETCH_WALLET_SUCCESS = "FETCH_WALLET_SUCCESS";
export const FETCH_WALLET_FAILURE = "FETCH_WALLET_FAILURE";

export const fetchUserWalletDetails = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_WALLET_REQUEST });
  try {
    let result = await AppointmentService.GetWalletMoney(payload);
    dispatch({ type: FETCH_WALLET_SUCCESS, payload: result?.data[0] });
  } catch (error) {
    dispatch({ type: FETCH_WALLET_FAILURE });
    // message.error("An error Occured....");
  }
};
